const randomNumber = (min: number, max: number) =>
  Math.floor(Math.random() * (1 + max - min) + min)

export { randomNumber }
